/**
 * SearchLG, subclass of SearchInterface
 * requires backbone.js
 */

var SearchLG = SearchInterface.extend({
	/** @lends SearchLG.prototype */


	/**
	 * Set the interface's config options
	 * @param {Object} config
	 * @param {Number} config.site_id system id
	 * @param {Number} config.guide_id guide id for the guide where the search originated (for stats purposes?)
	 * @param {Array} config.group_data group data
	 * @param {Object} config.searchwt weight for various search fields,
	 * @param {Bool} config.display_facets do we show facets or not
	 * @param {String} config.profile_url url for linking to profiles
	 */
	setConfig: function(config) {
		var defaults = {
			site_id: 0,
			guide_id: 0,
			group_data: [],
			display_facets: true,
			facets: {
				group:[],
				tag:[],
				guide_type:[],
				subject:[]
			},
			sort: { field: 'score', dir: 'desc' },
			sort_options: [
				{ field: 'score', dir: 'desc', label: this.get('lang').srch_sortlabelrel },
				{ field: 'updated', dir: 'desc', label: this.get('lang').srch_sortlabeldatedesc },
			],
			query_facet_results: {},
			searchwt: { guide: 6, page: 5, subject: 4, tag: 4, allInOne: 1 },
			profile_url: ''
		};

		_.extend(defaults, config);
		_.each(defaults, function(v,k,l){
			this.set(k, v, { silent: true });
		}, this);

		this.set('selector', '#s-srch-source-'+this.get('id'), { silent: true });

		//Listen for facets set form the controller's query string
		this.listenTo(searchcontroller, "facet:set", this.setLGFacet);
	},
	/**
	 * Set a facet without initiating a query or overwriting other facets
	 * used to set facets from query string by controller
	 * @param {Object} d data
	 * @param {String} d.facet name of facet
	 * @param {String} d.value value of facet to set
	 */
	setLGFacet: function(d) {
		if (d.facet && d.facet !== '' && d.value && d.value !== '') {
			//make sure we are only setting LG facets.
			if ( this.get('facets')[d.facet] ) {
				this.setFacet(d.facet, d.value, false, false);
			}
		}
	},
	/**
	 * Render the views
	 */
	renderViews: function() {
		var $container = jQuery(this.get('selector'));
		var views = []; //array of rows with views in them

		var searchheader = new SearchHeader({ model: this, id: 's-srch-header-'+this.get('id') });
		if (searchcontroller.get('layout') !== 'bento') {
			var top_pagination = new PaginationView({ model: this, id: 's-srch-paginate-'+this.get('id')+'-top', location: 'top' });
			var searchfooter = { '$el': '' };
		} else {
			var top_pagination = { '$el': '' };
			var searchfooter = new SearchFooter({ model: this, id: 's-srch-footer-'+this.get('id') });
		}
		var bottom_pagination = new PaginationView({ model: this, id: 's-srch-paginate-'+this.get('id')+'-bottom', location: 'bottom' });
		var params = new LGCurrentParamsView({ model: this, id: 's-srch-params-'+this.get('id') });
		var resultslist = new LGResultsList({ model: this, id: 's-srch-results-'+this.get('id') });
		//var askform = new AskView({ model: this, formType: 'noresults', alert_text: this.get('lang').srch_notasked, source: this.get('id') });

		if (this.get('description') !== '') {
			views.push(
				jQuery('<div class="row"></div>').append(
					jQuery('<div>').addClass('col-sm-12 s-srch-description').attr('id', 's-srch-description-'+this.get('id')).append(
						jQuery('<p>').html(this.get('description'))
					)
				)
			);
		}

		views.push( jQuery('<div class="row"></div>').append([searchheader.$el, top_pagination.$el]) );
		if (searchcontroller.get('layout') !== 'bento') {
			views.push( jQuery('<div class="row"></div>').append(params.$el) );
		}
		views.push( jQuery('<div class="row"></div>').append(resultslist.$el) );
		views.push( jQuery('<div class="row"></div>').append([searchfooter.$el, bottom_pagination.$el]) );
		//views.push( jQuery('<div class="row"></div>').append(askform.$el) );

		if (this.get('display_facets') === true) {
			var $col1 = jQuery('<div class="col-md-9 col-left"></div>').append(views);
			var $col2 = jQuery('<div class="col-md-3 col-right"></div>');

			//facet views
			var facetviews = [];
			_.each(this.get('facets'), function(v,k,l){
				facetviews.push( new LGFacetView({ model: this, id: 's-srch-facet-'+this.get('id')+'-'+k, facetType: k }) );
			}, this);
			_.each(facetviews, function(v,k){
				$col2.append(v.$el);
			}, this);
			$container.append( jQuery('<div class="row"></div>').append($col1, $col2) );
		} else {
			$container.append( views );
		}
	},
	/**
	 * Generate the query object for the search
	 * override in subclass
	 * sets the query_obj attribute
	 * @param {Boolean} [autocomp] is this an autocomplete request
	 */
	buildQuery: function(autocomp) {
		if (typeof autocomp == 'undefined') {
			autocomp = false;
		}

		qo = {
			search_source_id: this.get('id'),
			rows: this.get('perpage'),
			'facet.limit': 20,
			'group.limit': 4
		};

		//facets
		facets = this.get('facets');

		//site param
		qo['fq'] = [];
		qo['fq'].push('s:'+this.get('site_id'));

		var page = this.get('page');
		qo.start = (qo.rows * (page - 1));

		//we skip some stuff for autocomplete
		if (!autocomp) {
			_.each(facets, function(v,k,l){
				var facetquery = '';
				if (v.length > 0) {
					_.each(v, function(vx,kx,lx){
						facetquery += '"'+vx+'"';
						if (kx !== lx.length - 1) {
							facetquery += ' OR ';
						}
					}, this);
					qo['fq'].push(k+':('+facetquery+')');
				}

			}, this);

			qo.q = this.convertSearch();

			s = this.get('sort');
			qo.sort = s.field+' '+s.dir;

			this.set('query_obj', qo)
		} else {
			qo.facet = false;
			return qo;
		}

	},
	/**
	 * Take the typed query and fancy it up for use by the API
	 * override in subclass
	 */
	convertSearch: function() {
		//maybe we need to escape (with a backslash \ ) some characters: + - && || ! ( ) { } [ ] ^ " ~ * ? : \ /
		var typed = this.get('query_typed');
		//if (typed == '') { return '*:*'; }

		//typed = typed.replace(/([\(\)\[\]\{\}\^~:\\\/])/ig, '\\$1');
		return typed;
	},
	/**
	 * Request the data (an ajax request)
	 */
	requestData: function() {
		// if the request was coming from a LG2 site, call the local search function which returns fully rendered HTML
		if (typeof searchLg2Local !== 'undefined') {
			searchLg2Local(this.get('id'));
		}
		// else, the request is coming from another app (LA) so we make the API based search call which returns JSON formatted data
		else {
			var self = this;

			workingAlert();

			$.ajax({
			  url: this.protocol+'//'+this.get('request_url'),
			  data: this.get('query_obj'),
			  success: function(d, status){
				  clearTimeout(requestError);
				  self.cacheResults(d);
				  self.parseResults(d);
				  self.setFocus();
				  stopAlert();
			  },
			  traditional: true, //this lets the query have multiple parameters that don't use the [] syntax (cause solr wants that)
			  dataType: 'jsonp',
			  jsonp: 'json.wrf'
			});

			var requestError = setTimeout(function() {
			   // Handle error accordingly
			   errorAlert();
			}, 10000);
		}

        //track stats in LG
		if (typeof springSpace.springTrack !== 'undefined') {
			try {
				if (facets.group && facets.group.length > 0) {
					group_id = (typeof this.get('group_data')[facets.group[0]] !== 'undefined') ? this.get('group_data')[facets.group[0]].id : 0;
				} else {
                    group_id = 0;
                }

				if (this.get('query_typed') == '' || this.get('query_typed') == '*:*') { return; }

				springSpace.springTrack.trackSearch({ _st_type_id: '13', _st_group_id: group_id, _st_guide_id: this.get('guide_id'), _st_search_terms: this.get('query_typed') });
			} catch(e) {
				searchcontroller.debug(e);
			}
		}

	},
	/**
	 * Not doing this for LG
	 */
	retrieveFacets: function() {
		return;
	},
	/**
	 * Apply facet data retrieved from search
	 */
	parseFacets: function(data) {
		// only run for API based searches; local LG searches will process facets in searchLg2Local()
		if (typeof searchLg2Local == 'undefined') {
			this.set('facet_results', data.facet_counts.facet_fields);
			this.trigger('facets:retrieve');
		}
	},
	/**
	 * Grab the results and trigger some actions on the various views
	 * @param {Object} data returned from solr query
	 */
	parseResults: function(data) {
		this.set('results', data.grouped.g.groups);
		this.set('total_results', data.grouped.g.ngroups);
		this.set('query_facet_results', data.facet_counts.facet_fields);
		if (data.grouped.g.ngroups == 0) {
			this.trigger('search:noresults');
		} else {
			this.trigger('search:retrieve');
		}

		if (this.get('display_facets')) {
			// we only want to do this if the query string changes....
			if (this.facetCache[this.get('query_typed')]) {
				this.parseFacets(this.facetCache[this.get('query_typed')]);
			} else {
				this.cacheFacets(this.get('query_typed'), data);
				this.parseFacets(data);
			}
		}
	}

});


//!LGResultsList View
var LGResultsList = ResultsList.extend(
/** @lends LGResultsList.prototype */
{

	events: {
		'click .s-srch-result-subj a': 'setFacet',
	},
	/**
	 * render the results
	 */
    render: function () {
    	var $list = $('<ul class="list-unstyled s-srch-results"></ul>');
		var results = this.model.get('results');
		if(results.length > 0) {
			_.each(results, function(v,k,l){
				$list.append(this.resultItem(v));
			}, this);
		}
		this.$el.html($list);

		return this;
    },
    /**
     * When no results are retrieved empty results list. No results alert/form will appear.
     */
    noResults: function() {
    	$(this.el).html('');
    	return this;
    },
	/**
	 * Show the result
	 * @param {Object} result result object containing the grouped result data:
	 * @param {Array} result.doclist.docs is an array of page item
	 	item.doclist.docs.g: guide_id
	 	item.doclist.docs.p: page_id
	 	item.doclist.docs.guide: guide title
	 	item.doclist.docs.gd: guide description
	 	item.doclist.docs.subjects: array of subjects names
	 	item.doclist.docs.updated: last update Date
	 	item.doclist.docs.s: site_id
	 	item.doclist.docs.an: author (lastcommafirst)
	 	item.doclist.docs.aid: author id ???
	 	item.doclist.docs.slug: friendly url
	 	item.doclist.docs.pslug: page friendly url
	 * @return {Object} jQuery object
	 */
	resultItem: function(result) {
		var $li = $('<li></li>').addClass('s-srch-result');
		var html = '';

		var pages = result.doclist.docs;
        // Allow relative and absolute URLs.
		var domain = ( this.model.get('site_url') == '' ? '/' : '//' + this.model.get('site_url') );
		var item = result.doclist.docs[0]; //use first page result to get guide data
		if (!item.g) { item.g = ''; }
		if (!item.guide) { item.guide = ''; }
		if (!item.gd) { item.gd = ''; }
		if (!item.aid) { item.aid = ''; }

		var qurl = ( domain == '/' ? domain : domain + '/' );
		if (item.slug && item.slug !== '') {
			qurl += item.slug;
		} else {
			qurl += 'c.php?g='+item.g;
		}
		item.url = qurl;

		if (!item.updated_formatted) {
			var date = new Date(item.updated);
			item.updated_formatted = date.format(this.model.get('lang').Dt_DateTime);
		}

		item.pages = [];
		_.each(pages, function(v,k,l){
            var purl = ( domain == '/' ? domain : domain + '/' );
			if (v.pslug && v.pslug !== '') {
				purl += v.pslug;
			} else if (v.slug && v.slug !== '') {
				purl += v.slug+'?p='+v.p;
			} else {
				purl += 'c.php?g='+v.g+'&p='+v.p;
			}
			item.pages.push({ url: purl, title: v.page });
		}, this);

		item.profile_url = this.model.get('profile_url')+item.aid;
		item.an = (item.an) ? item.an.replace(',', ', ') : '';
		if (typeof item.subject == 'undefined') { item.subject = []; }

		if (this.model.get('item_template') === '') {
			if (searchcontroller.get('layout') == 'bento') {
				this.model.set('item_template',
				'<div class=s-srch-result-title>'+
					'<a href="{{url}}" data-guide_id={{g}}>{{guide}}</a>'+
				'</div>'+
				'{{# if (gd !== "") { }}<p class=s-srch-result-desc">{{gd}}</p>{{# } }}'+
				'<div class="s-srch-result-meta">'+
					'<span class="s-srch-result-author"><span class=metalabel>'+this.model.get('lang').srch_by+'</span><a href="{{profile_url}}">{{an}}</a></span><span class="divider" aria-hidden="true">|</span>'+
					'<span class="s-srch-result-date"><span class=metalabel>'+this.model.get('lang').srch_update+'</span> {{updated_formatted}}</span>'+
					'{{# if (subject.length > 0) { }}'+
						'<span class="divider" aria-hidden="true">|</span>'+
						'<span class="s-srch-result-subj">'+
							'<span class=metalabel>'+this.model.get('lang').srch_subject+'</span>'+
							'<ul class="list-inline metavalue" aria-label="'+this.model.get('lang').srch_subject+'">'+
								'{{# _.each(subject, function(v,k){ }}'+
									'<li>{{v}}'+
									'{{# if (k+1 < subject.length){ print(\';\'); } }}'+
									'</li>'+
								'{{# }); }}'+
							'</ul>'+
						'</span>'+
					'{{# } }}'+
				'</div>',
				{ silent: true });
			} else {
				this.model.set('item_template',
				'<div class=s-srch-result-title>'+
					'<a href="{{url}}" data-guide_id={{g}}>{{guide}}</a>'+
				'</div>'+
				'{{# if (gd !== "") { }}<p class=s-srch-result-desc">{{gd}}</p>{{# } }}'+
				'<div class="s-srch-result-meta">'+
					'{{# if (pages.length > 0) { }}'+
						'<ul class="s-srch-result-pages">'+
							'{{# _.each(pages, function(v){ }}'+
								'<li><a href="{{v.url}}">{{v.title}}</a></li>'+
							'{{# }); }}'+
						'</ul>'+
					'{{# } }}'+
					'<span class="s-srch-result-author"><span class=metalabel>'+this.model.get('lang').srch_by+'</span><a href="{{profile_url}}">{{an}}</a></span><span class="divider" aria-hidden="true">|</span>'+
					'<span class="s-srch-result-date"><span class=metalabel>'+this.model.get('lang').srch_update+'</span> {{updated_formatted}}</span>'+
					'{{# if (subject.length > 0) { }}'+
						'<span class="divider" aria-hidden="true">|</span>'+
						'<span class="s-srch-result-subj">'+
							'<span class=metalabel>'+this.model.get('lang').srch_subject+'</span>'+
							'<ul class="list-inline metavalue" aria-label="'+this.model.get('lang').srch_subject+'">'+
								'{{# _.each(subject, function(v){ }}'+
									'<li><span class="label label-default"><a href="#" data-subject="{{{v}}}">{{v}}</a></span></li>'+
									//'<li><a href="#" data-subject="{{{v}}}">{{v}}</a>;</li>'+
								'{{# }); }}'+
							'</ul>'+
						'</span>'+
					'{{# } }}'+
				'</div>',
				{ silent: true });
			}
		}

		if (this.item_template === '') {
			this.item_template = _.template( this.model.get('item_template') );
		}

		try {
			html = this.item_template(item);
		} catch(e) {
			searchcontroller.debug(e);
			return '';
		}
		return $li.html( html );
	},

	/**
	 * Clicking on a result title... does nothing right now, but it could do stats
	 */
	gotoAnswer: function(e) {
		return true;
	},
	/**
	 * Clicking on a topic in the results sets that topic as the only facet filter
	 */
	setFacet: function(e) {
		e.preventDefault();
		var subject = $(e.currentTarget).attr('data-subject').toLowerCase();
		this.model.setFacet('subject', subject);
	}

});


//!LGCurrentParamsView
var LGCurrentParamsView = CurrentParamsView.extend(
/** @lends LGCurrentParamsView.prototype */
{
	/**
	 * create the display
	 */
	render: function() {
		this.$el.html('');
		var $container = jQuery('<div></div>').addClass('s-srch-params').attr({ 'aria-live': 'polite', 'aria-relevant': 'text' });

		var facetData = this.model.get('facets');

		var links = [];
		//iterate the facet types
		_.each(facetData, function(f, t){
			if (f.length > 0) {
				//iterate the values on the specific facet
				$li = jQuery('<li></li>');
				$li.append('<span>'+this.model.get('lang')['srch_filters_'+t]+':</span> ');
				var html = ' ';
				_.each(f, function(v,k,l) {
					var f_value = v;
					html += '"'+f_value+'"';
					if (l.length > (k + 1)) {
			    	 	html += ' OR ';
		    	    }
				}, this);

				if (f.length > 1) {
					html = '('+html+')';
				}
				var $filterNames = $('<span></span>').text(html);
        		$li.append($filterNames);
				links.push($li);
			}
		}, this);

		//add a remove all link if appropriate
		if (links.length > 0) {
			$li = jQuery('<li></li>').append(
		    	        jQuery('<a href="#" class="removeAll" aria-controls="s-srch-results-'+this.model.get('id')+'"></a>')
		    	        .html('<i class="fa fa-times-circle"></i> '+this.model.get('lang').srch_facetremoveall)
		    	    );
			links.push($li);
		}

		if (links.length > 0) {
			this.$list = $('<ul class="list-inline"></ul>');
			_.each(links, function(v){
				this.$list.append(v);
			}, this);

			$container.append(['<h3>'+this.model.get('lang').srch_filtercurr+'</h3>', this.$list]);
			this.$el.append($container).removeClass('hidden');
		} else {
			this.$el.addClass('hidden');
		}
		return this;
	}
});


//!LGFacetView
var LGFacetView = FacetView.extend(
/** @lends LGFacetView.prototype */
{

	/**
	 * create the display
	 */
	render: function() {
		searchcontroller.debug('LGFacetView render');
		searchcontroller.debug(this.facetType);
		switch(this.facetType) {
			case 'group':

				this.makeLabel = function(name) {
					return (typeof this.model.get('group_data')[name] !== 'undefined') ? this.model.get('group_data')[name].name : name;
				}
				this.facetSelected = function(v) { return (this.model.get('facets')[this.facetType].indexOf(v) > -1) }
				break;
			case 'guide_type':
				this.makeLabel = function(name) { return name.capitalize(); }
				this.facetSelected = function(v) { return (this.model.get('facets')[this.facetType].indexOf(v) > -1) }
				break;
			case 'subject':
				this.makeLabel = function(name) { return name.capitalize(); }
				this.facetSelected = function(v) { return (this.model.get('facets')[this.facetType].indexOf(v) > -1) }
				break;
			case 'tag':
				this.makeLabel = function(name) { return name.capitalize(); }
				this.facetSelected = function(v) { return (this.model.get('facets')[this.facetType].indexOf(v) > -1) }
				break;
		}
		this.header = this.model.get('lang')['srch_filters_'+this.facetType];

		this.$el.html('');
		this.$el.append('<h3><button class="btn btn-default s-srch-facet-btn" type=button data-toggle="collapse" data-target="#s-srch-'+this.model.get('id')+'-cloud-'+this.facetType+'"><span class="s-srch-side-collapse"><i class="fa fa-caret-down"></i></span> '+this.header+'</button></h3>');

		this.$list = $('<ul class="s-srch-cloud list-unstyled collapse in" id="s-srch-'+this.model.get('id')+'-cloud-'+this.facetType+'"></ul>');
		this.$el.append(this.$list);

		return this;
	},

	/**
	 * Generate the list of facet values
	 */
	makeList: function() {
		this.$list.empty();

		var facetData = this.model.get('facet_results');
		var curFacets = this.model.get('facets')[this.facetType];
		var list = [];
		if (facetData) {
			_.each(facetData[this.facetType], function(v,k,l) {
				var checked = this.facetSelected(k);
				var $li = jQuery('<li></li>');
				var $label = jQuery('<label class="check"></label>');
				var $input = jQuery('<input type="checkbox" />').attr('name', k).prop('checked', checked).attr('aria-controls', 's-srch-results-'+this.model.get('id'));

				$label.append($input).append(' '+this.makeLabel(k)+' (' + v +')');
				$li.append($label);

				list.push($li);
			}, this);
		}
		if (list.length == 0) {
			this.$list.append('<li>'+this.model.get('lang').srch_facetnone+'</li>');
		} else {
			_.each(list, function(v){
				this.$list.append(v);
			}, this);
		}
	},

});
